import { useLocation, To, parsePath } from 'react-router-dom';

import { GetLocationDescriptorSettings } from '@cast/utils';
import { useOrganizations } from '@cast/shared-organization-context-data-access';
import { addOrgIdToLocation } from '@cast/infrastructure-organization';

export const useLocationWithOrgId = (
  path?: To,
  settings?: GetLocationDescriptorSettings
) => {
  const { currentOrganization } = useOrganizations();
  const location = useLocation();
  const parsedPath = typeof path === 'string' ? parsePath(path) : path;
  return addOrgIdToLocation(currentOrganization?.id, {
    path: parsedPath,
    location,
    locationSettings: settings,
  });
};
